import React from 'react';

import styled from 'styled-components';

import CarouselCard from 'components/Carousel/CarouselCard';
import CtaButton from 'components/CtaButton/CtaButton';

import { FinalCardI } from 'interfaces/content-stack/contentStack.types';

import { getModularBlockLinkData } from 'utils/modularBlockUtils';

const Card = styled.div`
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  background-color: ${(props) => props.theme.colors.whiteSmoke};
  cursor: pointer;
  flex-direction: column;
  text-decoration: none;
  display: flex;
  height: 100%;
`;

const CTAText = styled.div`
  font-size: 1.25rem;
  font-family: ${({ theme }) => theme.fonts.default};
  font-weight: 500;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 1.15rem;
  }
`;

interface FinalCardProps {
  finalCard: FinalCardI;
  urlHref?: string;
}

const FinalCard: React.FC<FinalCardProps> = ({ finalCard, urlHref }) => {
  const { link, openInNewWindow } = getModularBlockLinkData(finalCard.buttonCta.buttonLink);

  return (
    <CarouselCard>
      <Card>
        <CTAText>{finalCard.ctaText ?? 'See more news'}</CTAText>
        <CtaButton
          to={urlHref ?? link}
          openInNewWindow={openInNewWindow}
          text={finalCard.buttonCta.buttonText}
          buttonType={finalCard.buttonCta.buttonType}
          small
          disableStretch
          dataLayerInfo={finalCard.ctaText ?? 'See more news'}
        />
      </Card>
    </CarouselCard>
  );
};

export default FinalCard;
